import createLucideIcon from '../createLucideIcon';

const Code2 = createLucideIcon('Code2Icon', [
  ['path', { d: 'm18 16 4-4-4-4', key: '1inbqp' }],
  ['path', { d: 'm6 8-4 4 4 4', key: '15zrgr' }],
  ['path', { d: 'm14.5 4-5 16', key: 'e7oirm' }],
]);

export default Code2;
